<template>
  <div class="gc-data-grid-report">
    <!-- <GcDataGrid
      :grouping="true"
      :export="true"
      :summary="true"
      :exportFileName="exportFileName"
      :dataSourceConfig="dataSourceConfig"
      :columns="columns"
      :gridToolbar="gridToolbar"
      :padColumn="true"
      :id="'grid-report-grid'"
      :rowClick="rowClickCallBack"
      :auto-expand-all="false"
      :gridOptions="gridOptions"
    /> -->
    <GcDataGrid
      :grouping="true"
      :export="true"
      :summary="true"
      :exportFileName="exportFileName"
      :dataSourceConfig="dataSourceConfig"
      :columns="columns"
      :gridToolbar="getGridToolbar"
      :padColumn="true"
      :id="'grid-report-grid'"
      :rowClick="rowClickCallBack"
      :auto-expand-all="false"
      :gridOptions="gridOptions"
      :title="title"
      :persistenceKey="persistenceKey"
      :heightPadding="heightPadding"
    />
  </div>
</template>

<script>
// import GcDataGrid from "./gc-data-grid";

export default {
  props: {
    persistenceKey: {
      type: String,
    },
    exportFileName: {
      type: String,
    },
    dataSourceConfig: {
      type: Object,
    },
    columns: {
      type: Array,
    },
    rowClickCallBack: {
      type: Function,
      default: () => {},
    },
    gridOptions: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: "grid-report",
    },
    heightPadding: {
      type: Number,
      default: 0,
    },
    gridToolbar: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    //
    return {};
  },
  components: {
    // GcDataGrid,
  },
  computed: {
    getGridToolbar() {
      if (this.gridToolbar) return this.gridToolbar;
      else
        return {
          search: true,
          columnChooser: true,
          export: true,
          openFilter: true,
        };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
